module.exports = __webpack_public_path__ + "static/img/LogoAcs.ae170c16.svg";